module.exports = __webpack_public_path__ + "img/C.7c1d0a73.png";